const floatingChatStyles = `
.floating-chat {
	/* The window chrome (the header tab bar) lives outside .ai-ws, but inherits the
	   --ws-* theme vars from ShadcnScope's [data-ai-tokens] portal container (WEB-8001) —
	   the sheet previously mirrored the values here by hand. */
	position: relative;
	display: flex;
	flex-direction: column;
	width: 100%;
	height: 100%;
	background: var(--ws-panel);
	/* Rounding, the hairline ring, the drop shadow and the rounded clip live on the draggable
	   wrapper (the element react-draggable transforms), NOT here — see FloatingAIChat.tsx. A
	   rounded overflow clip on a descendant of a transformed element is mis-composited by
	   Chromium and leaks square corners. The plain (square) containment clip for the chat's
	   own children lives here; the wrapper applies the rounded corners. clip, not hidden —
	   hidden is still programmatically scrollable and scrollIntoView/focus would shift the
	   window content. */
	overflow: hidden;
	overflow: clip;
}
.floating-chat-head {
	display: flex;
	align-items: center;
	justify-content: space-between;
	gap: 8px;
	padding: 6px 8px;
	border-bottom: 1px solid var(--ws-line);
	cursor: move;
	user-select: none;
	/* No own background: .floating-chat is white and rounded, and the overflow clip is
	   unreliable on the header's top corners under react-draggable's transformed ancestor
	   (it leaves them square). With a transparent header the rounded parent white shows at
	   the corners — nothing square to clip. The header only contributes its bottom divider. */
	background: transparent;
	flex: 0 0 auto;
}
/* Persistent tab bar (Chat · Inbox · Conversations · New chat). Doubles as drag surface:
   react-draggable distinguishes a click (activates a tab) from a drag (moves the window). */
.floating-chat-tabs { display: flex; align-items: center; gap: 2px; min-width: 0; }
.floating-chat-tab {
	display: inline-flex;
	align-items: center;
	gap: 5px;
	padding: 5px 9px;
	border: none;
	background: transparent;
	color: var(--ws-ink-4);
	font-family: var(--ws-sans);
	font-size: 13px;
	font-weight: 600;
	line-height: 1;
	white-space: nowrap;
	cursor: pointer;
	border-radius: var(--ws-r-sm);
}
.floating-chat-tab:hover { color: var(--ws-ink-2); background: var(--ws-soft); }
.floating-chat-tab.is-active { color: var(--ws-ink); background: var(--ws-soft); }
/* New chat is an action, not a view — never carries the active state. */
.floating-chat-tab--action { color: var(--ws-ink-3); }
.floating-chat-tab--action svg { width: 15px; height: 15px; }
.floating-chat-tab-count {
	display: inline-flex;
	align-items: center;
	justify-content: center;
	margin-bottom: 1px;
	min-width: 16px;
	height: 16px;
	padding: 0 4px;
	box-sizing: border-box;
	border-radius: 8px;
	background: var(--ws-accent);
	color: #fff;
	font-size: 9px;
	font-weight: 700;
	font-variant-numeric: tabular-nums;
}
.floating-chat-body { flex: 1; min-height: 0; display: flex; }
.floating-chat-body .ai-ws-embed { width: 100%; height: 100%; }
/* The shared workspace styles hardcode height:100vh on .ai-ws/.ws-main (correct for the
   full-screen workspace + extension panel, wrong inside this small window) — that pushed
   the message thread + composer off-screen below the window, leaving it blank. Override
   to fill the window instead. */
.floating-chat .ai-ws { display: flex; height: 100%; min-height: 0; }
.floating-chat .ws-main { height: 100%; min-height: 0; flex: 1; }
/* Inbox / Conversations tab panes — fill the body and let their inner scroller (WorkspaceInbox's
   .ws-history, or .embed-conv-list) scroll. Live inside .ai-ws so they inherit the --ws-* palette. */
.floating-chat-pane { flex: 1; min-height: 0; display: flex; flex-direction: column; }
/* The tab already says "Inbox" — hide WorkspaceInbox's own h1 so the title isn't duplicated. */
.floating-chat-pane .ws-history-title { display: none; }
/* The page-width gutters (24px 32px 48px) cost ~16% of a 400px-wide window; that width belongs
   to the row titles and previews instead (WEB-8800). */
.floating-chat-pane .ws-history-inner { padding: 14px 12px 32px; }
`;

export default floatingChatStyles;
